import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import HomePage from './Pages/HomePage';
import AboutPage from './Pages/AboutPage';
import Services from './Pages/Services';
import './css/bootstrap.min.css';
// import './css/font-awesome.min.css';
import './css/animate.css';
// import './css/owl.carousel.css';
// import './css/owl.theme.css';
import './css/main.css';
import './css/shortcodes.css';
import InspectionServices from './Pages/InspectionServices';
import AuditReport from './Pages/AuditReport';
import ContaactUs from './Pages/ContaactUs';
import Blog from './Pages/Blog';
import BlogSingle from './Pages/BlogSingle';
import BlogDouble from './Pages/BlogDouble';
import BlogTriple from './Pages/BlogTriple';
import ScrollToTop from './Component/NavBarFooter/ScrollToTop';

function App() {
  return (
   <BrowserRouter>
   <ScrollToTop/>
   <Routes>

    <Route path='/' element={<HomePage/>}/>
    <Route path='/about-us' element={<AboutPage/>}/>
    {/* <Route path='/services/:id' element={<Services/>}/> */}
    <Route path='/kitchen-textile' element={<Services/>}/>
    <Route path='/garments' element={<Services/>}/>
    <Route path='/work-gloves' element={<Services/>}/>
    <Route path='/uniforms' element={<Services/>}/>
    <Route path='/cotton-tote-bags' element={<Services/>}/>
    <Route path='/drawstring-bags' element={<Services/>}/>
    <Route path='/promotional-bags' element={<Services/>}/>
    <Route path='/personalized-bags' element={<Services/>}/>
    <Route path='/laundry-bags' element={<Services/>}/>
    <Route path='/cotton-sacks' element={<Services/>}/>
    <Route path='/cotton-pouches' element={<Services/>}/>
    <Route path='/non-woven-bags' element={<Services/>}/>
    <Route path='/inspection-services' element={<InspectionServices/>}/>
    <Route path='/audit-services' element={<AuditReport/>}/>
    <Route path='/contact-us' element={<ContaactUs/>}/>
    <Route path='/hospital-textile' element={<Services/>}/>
    <Route path='/promotional-textile' element={<Services/>}/>
    <Route path='/bath-towels' element={<Services/>}/>
    <Route path='/kids-towels' element={<Services/>}/>
    <Route path='/hotel-towels' element={<Services/>}/>
    <Route path='/jacquard-towels' element={<Services/>}/>
    <Route path='/luxury-towels' element={<Services/>}/>
    <Route path='/bathrobes' element={<Services/>}/>
    <Route path='/promotional-towels' element={<Services/>}/>
    <Route path='/beach-towels' element={<Services/>}/>
    <Route path='/blog' element={<Blog/>}/>
    <Route path='/5-hidden-costs-in-garment-manufacturing-and-how-to-avoid-them' element={<BlogSingle/>}/>
    <Route path='/steps-to-create-a-strong-supply-chain-for-your-fashion-brand' element={<BlogSingle/>}/>
    <Route path='/benefits-of-working-with-a-sourcing-partner-vs-going-direct-to-the-factory' element={<BlogSingle/>}/>
    <Route path='/how-frequent-factory-visits-and-surveys-help-evade-the-risks' element={<BlogSingle/>}/>
    <Route path='/blog-double' element={<BlogDouble/>}/>
    <Route path='/blog-triple' element={<BlogTriple/>}/>

   </Routes>
   </BrowserRouter>
  );
}

export default App;
